/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate, useParams } from "react-router-dom";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { differenceInDays } from "../../utils/diferentDays";
import moment from "moment/moment";
import "moment/locale/es";
import { selectPrice } from "../../utils/details";
import { URL_API } from "../../config/default";
import perfil from "../../assets/img/usuario-negro.png";
import excursionesDia from "../../assets/img/excursiones-dia.png";
import tourCompletos from "../../assets/img/tour-dia-completo.png";
import gastronomico from "../../assets/img/gastronomia.png";
import recorrido from "../../assets/img/recorrido-auto.png";
import aventura from "../../assets/img/aventura.png";
import toursPrivado from "../../assets/img/tour-turistico-privado.png";
import cataVino from "../../assets/img/cata-vino.png";
import tourPie from "../../assets/img/tours-pie.png";
import naturaleza from "../../assets/img/naturaleza.png";
import arqueologo from "../../assets/img/arqueologo.png";
import almuerzo from "../../assets/img/almuerzo.png";
import desayuno from "../../assets/img/desayuno.png";
import merienda from "../../assets/img/meriendas.png";
import bebidas from "../../assets/img/bebidas-sin-alcohol.png";
import traslados from "../../assets/img/traslados.png";
import guia from "../../assets/img/guia-turistico.png";
import cancelacion from "../../assets/img/cancelar-gratis.png";
import espanol from "../../assets/img/espanol.png";
import accesible from "../../assets/img/silla-de-ruedas.png";
import mascotas from "../../assets/img/pista.png";
import recogida from "../../assets/img/recorrido-auto.png";
import servicio from "../../assets/img/ayuda-seguridad.png";
import Galeria from "../../components/UI/Alquiler/Galeria";
import { MapPin, Star } from "lucide-react";
import { Qualy } from "../../utils/qualy";
import { Button } from "../../components/UI/Button";
import { Card, CardContent } from "../../components/UI/Card";
import ReviewsSection from "../../components/UI/reviews-section";
import SEO from "../../components/SEO";
import { Skeleton } from "../../components/UI/Skeleton";

const DetalleExcursion = () => {
  localStorage.removeItem("reserva");
  const navigate = useNavigate();
  const { slug } = useParams();
  const [showGallery, setShowGallery] = useState(false);
  const actividades = [
    {
      name: "Excursiones de día",
      icon: excursionesDia,
    },
    {
      name: "Tour días completos",
      icon: tourCompletos,
    },
    {
      name: "Tours gastronómicos",
      icon: gastronomico,
    },
    {
      name: "Recorridos en auto",
      icon: recorrido,
    },
    {
      name: "Tours turísticos",
      icon: tourCompletos,
    },
    {
      name: "Tours de aventura",
      icon: aventura,
    },
    {
      name: "Tours turisticos privados",
      icon: toursPrivado,
    },
    {
      name: "Tour de medio días",
      icon: tourCompletos,
    },
    {
      name: "Cata de vino",
      icon: cataVino,
    },
    {
      name: "Tours a pie",
      icon: tourPie,
    },
    {
      name: "Paseos por la naturaleza",
      icon: naturaleza,
    },
    {
      name: "Visitas arqueológicas",
      icon: arqueologo,
    },
    {
      name: "Almuerzo",
      icon: almuerzo,
    },
    {
      name: "Desayuno",
      icon: desayuno,
    },
    {
      name: "Merienda",
      icon: merienda,
    },
    {
      name: "Bebidas",
      icon: bebidas,
    },
    {
      name: "Traslados",
      icon: traslados,
    },
    {
      name: "Guía profesional",
      icon: guia,
    },
    {
      name: "Cancelación gratis",
      icon: cancelacion,
    },
    {
      name: "Actividades en español",
      icon: espanol,
    },
    {
      name: "Accesible a sillas de ruedas",
      icon: accesible,
    },
    {
      name: "Admite mascotas",
      icon: mascotas,
    },
    {
      name: "Recogida en alojamiento",
      icon: recogida,
    },
    {
      name: "Servicio privado",
      icon: servicio,
    },
  ];

  const openGallery = () => {
    setShowGallery(true);
  };

  const onReserve = async (excursion: any) => {
    localStorage.removeItem("reserva-excursion");
    excursion.title = encodeURIComponent(excursion.title);
    excursion.description = encodeURIComponent(excursion.description);
    excursion.prices = [];
    let fees: any = [];
    excursion.fees = fees;
    const propertyEncode = JSON.stringify(excursion);
    const payload: any = {
      excursion: true,
      property: propertyEncode,
      dateRange: dateRange && dateRange[0],
      differenceDay: differenceInDays(
        dateRange && dateRange[0].startDate,
        dateRange && dateRange[0].endDate
      ),
    };

    localStorage.setItem("reserva", JSON.stringify(payload));
    return navigate("/reservar");
  };

  const [dateRange, setDateRange] = useState<{ startDate?: any; endDate?: any; key?: any }[]>();

  const { isPending, error, data } = useQuery({
    queryKey: ["excursion"],
    queryFn: () => {
      return fetch(`${URL_API}/excursions/${slug}`).then(async (res) => {
        const response = await res.json();
        setDateRange([
          {
            startDate: new Date(),
            endDate: new Date(
              moment()
                .add(response.data.min_nights, "day")
                .format("YYYY-MM-DD HH:mm:ss")
            ),
            key: "selection",
          },
        ]);
        return response;
      });
    },
  });

  if (isPending) {
    return (
      <div className="container mx-auto px-6 lg:px-[50px] py-6">
        {/* Title Section Skeleton */}
        <div className="mb-6">
          <Skeleton className="h-8 w-3/4 mb-2" />
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>

        {/* Image Gallery Skeleton */}
        <div className="mb-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 rounded-xl overflow-hidden">
            <div className="lg:col-span-2 lg:row-span-2">
              <Skeleton className="h-64 sm:h-80" />
            </div>
            <div className="hidden lg:grid lg:col-span-2 grid-cols-2 gap-2">
              <Skeleton className="h-40" />
              <Skeleton className="h-40" />
              <Skeleton className="h-40" />
              <Skeleton className="h-40" />
            </div>
          </div>
        </div>

        {/* Main Content Skeleton */}
        <div className="grid lg:grid-cols-3 grid-cols-1 py-3">
          {/* Left Column */}
          <div className="lg:col-span-2 space-y-8">
            {/* Host Info Skeleton */}
            <div className="flex items-center gap-3 p-4 border rounded-lg">
              <Skeleton className="w-10 h-10 rounded-full" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>

            {/* Description Skeleton */}
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>

            {/* Activities Skeleton */}
            <div>
              <Skeleton className="h-6 w-48 mb-4" />
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
              </div>
            </div>
          </div>

          {/* Right Column - Booking Card Skeleton */}
          <div className="lg:col-span-1">
            <Card className="shadow-lg border">
              <CardContent className="p-6 space-y-4">
                <Skeleton className="h-6 w-3/4" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-1/2" />
                </div>
                <Skeleton className="h-12 w-full" />
                <Skeleton className="h-4 w-full" />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    );
  }

  if (error) return "An error has occurred: " + error.message;

  const excursion = data.data;

  if (showGallery) {
    return (
      <Galeria
        images={excursion.images}
        show={showGallery}
        onClose={() => setShowGallery(false)}
      />
    );
  }

  const url = window.location.href;
  return (
    <div className="container mx-auto px-6 lg:px-[50px] py-6">
      <SEO
        title={excursion.title}
        description={excursion.description}
        name={`${excursion.owner.firstname} ${excursion.owner.lastname}`}
        type="website"
        canonicalUrl={url}
        keywords={`excursion, ${excursion.city}, ${excursion.province}, tour, actividad`}
        image={excursion?.images.length > 0 ? excursion.images[0].url : ""}
        twitterHandle="@tu_usuario_twitter"
      />

      {/* Title Section */}
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
          {excursion.title}
        </h1>
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            <span className="font-medium">
              {Qualy(excursion.reviews).total["total"]}
            </span>
            <span>({excursion.reviews.length} reseñas)</span>
          </div>
          <div className="flex items-center gap-1">
            <MapPin className="w-4 h-4" />
            <span>{excursion.city}</span>
          </div>
        </div>
      </div>

      {/* Image Gallery */}
      <div className="mb-8">
        <div className={`grid  gap-2 rounded-xl overflow-hidden grid-cols-1 ${excursion?.images.length > 1 ? 'lg:grid-cols-4' : 'lg:grid-cols-1'}`}>
          {/* Main Image */}
          <div className="lg:col-span-2 lg:row-span-2">
            <div
              className={`relative h-64 sm:h-80 cursor-pointer group`}
              onClick={() => openGallery()}
            >
              <img
                src={
                  excursion?.images.length > 0
                    ? excursion.images[0].url
                    : "/placeholder.svg"
                }
                alt="Vista principal"
                className={`absolute object-cover w-full h-full group-hover:brightness-90 transition-all duration-300`}
              />
            </div>
          </div>

          {/* Secondary Images */}
          <div className="hidden lg:grid lg:col-span-2 grid-cols-2 gap-2">
            {excursion.images.slice(1, 5).map((image: any, index: number) => (
              <div
                key={index}
                className="relative h-40 cursor-pointer group"
                onClick={() => openGallery()}
              >
                <img
                  src={image.url}
                  alt={`Vista ${index + 2}`}
                  className="absolute object-cover w-full h-full group-hover:brightness-90 transition-all duration-300"
                />
                {index === 3 && excursion.images.length > 5 && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                    <span className="text-white font-medium">
                      +{excursion.images.length - 5} fotos
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Gallery Button */}
        <div className="lg:hidden mt-4">
          <Button
            variant="outline"
            onClick={() => openGallery()}
            className="w-full"
          >
            Ver todas las fotos ({excursion.images.length})
          </Button>
        </div>
      </div>


      {/* Main Content */}
      <div className="grid lg:grid-cols-3 grid-cols-1 py-3">
        {/* Left Column */}
        <div className="lg:col-span-2 space-y-8">
          {/* Property Info */}
          <div>
            {/* Host Info */}
            <div className="flex items-center gap-3 p-4 border rounded-lg">
              <img
                src={excursion.owner.image ?? perfil}
                alt={`${excursion.owner.firstname} ${excursion.owner.lastname}`}
                width={40}
                height={40}
                className="rounded-full"
              />
              <div>
                <div className="font-medium">
                  Anfitrión:{" "}
                  {`${excursion.owner.firstname} ${excursion.owner.lastname}`}
                </div>
                <div className="text-sm text-gray-600">
                  Identidad verificada
                </div>
              </div>
            </div>
          </div>


          {/* Description */}
          <div className="mb-3">
            <p className="text-gray-700 leading-relaxed">
              {excursion.description}
            </p>
          </div>

          {/* Description */}
          <div className="mb-3">
            <p className="text-black leading-relaxed">
              {excursion.description_long}
            </p>
          </div>


          {/** Amenities */}
          <div>
            <span className="w-48 text-xl font-bold text-black">
              ¿Qué ofrece este lugar?
            </span>
            <div className="w-full text-md font-bol text-black my-4 grid lg:grid-cols-2 grid-cols-1">
              {excursion.activities.map((s: any) => (
                <div className="w-full font-bold text-black mb-1 flex py-2">
                  <img
                    src={actividades.filter((i) => i.name == s.name)[0]?.icon}
                    className="me-2 w-[20px]"
                    alt=""
                  />
                  {s.name}
                </div>
              ))}
            </div>
          </div>


          {/* Reviews */}
          <div className="mb-6">
            <ReviewsSection reviews={excursion.reviews} />
          </div>
        </div>



        {/* Right Column - Booking Card */}
        <div className="lg:col-span-1">

          <div className="sticky top-24">
            <Card className="shadow-lg border">
              <CardContent className="p-6">

                <span className="font-bold text-black">{`${selectPrice(excursion.price, [], 1)
                    .toLocaleString(
                      "de-DE",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )} ${excursion.currency}`}</span>

                <div className="flex justify-between py-1 w-full">
                  <span className="">{`Inicio de la excursion ${moment(
                    excursion.start_date
                  )
                    .locale("es")
                    .format("D [de] MMMM [de] YYYY")}`}</span>
                </div>

                <div className="flex justify-between py-1 w-full">
                  <span className="">Duracion</span>
                  <span className="text-black font-bold">{` ${excursion.duration} horas`}</span>
                </div>

                <div className="w-full ">
                  <div className="flex justify-center">
                    <label
                      className="cursor-pointer text-white py-2 px-5 bg-[#8B9456] w-full text-center"
                      style={{ borderRadius: "10px" }}
                    >
                      Reservar
                      <button
                        className="hidden"
                        onClick={() => onReserve(excursion)}
                      ></button>
                    </label>
                  </div>
                </div>
                <hr />
                <div className="flex justify-between py-3 w-full">
                  <span className="">Total</span>
                  <span className="text-black font-bold">{`${selectPrice(excursion.price, [], 1)
                      .toLocaleString(
                        "de-DE",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )} ${excursion.currency}`}</span>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

    </div>
  );
};

export default DetalleExcursion;
